import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface NotionalFieldProps {
  placeholder?: string
}

export const NotionalField: React.FC<NotionalFieldProps> = ({ placeholder }) => {
  const { control, register } = useFormContext<{ notional: number }>()

  return (
    <FormField
      name="notional"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Notional</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput
              thousandSeparator={','}
              {...register('notional')}
              placeholder={placeholder ?? 'Enter the notional'}
            />
          </FormItem>
        )
      }}
    />
  )
}
